import { Bot } from "./types";
import { BOTS, PROFESSIONAL_BOTS } from "../config/constants";

export const isProfessionalBot = (id: string): boolean => {
  return PROFESSIONAL_BOTS.some((bot) => bot.id === id);
};

export const getBot = async (id: string): Promise<Bot | null> => {
  const allBots = [...BOTS, ...PROFESSIONAL_BOTS];
  const bot = allBots.find((bot) => bot.id === id);
  return bot || null;
};
